export default {
    handle(bloodDonorModel) {
        bloodDonorModel.blood_donor_in_other_country = bloodDonorModel.blood_donor_in_other_country === 'yes';

        return true;
    }
}